export default callback => {
  // is server?
  if (typeof window === `undefined`) {
    callback();
  } else {
    setTimeout(callback);
  }
};
